<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">INV相違一覧</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search">検索</v-btn>
        <v-btn @click="confirmInv" v-permit.SHARP_ICS_INV_CONFIRM>INV確認処理</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="海外取引先"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field label="INV NO" v-model="query.invoiceNo"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="inline-edit"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.invoiceNo }}</td>
          <td>{{ props.item.ifHandleFlag }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      results: [],
      selected: [],
      query: {},
      loading: false,
      headers: [
        { text: '海外取引先', value: 'partnerName', sortable: false },
        { text: 'INV No', value: 'invoiceNo', sortable: false },
        { text: '処理Status', value: 'status', sortable: false }
      ],
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  methods: {
    search() {
      this.autoload = true
      this.$storeParams()
      this.load()
    },
    load() {
      this.$http
        .get('/commercial-invoices/to-deal', this.params())
        .then(res => {
          this.results = res.data
        })
    },
    confirmInv() {
      this.$router.push({
        path: '/B2001',
        query: {
          no: this.selected[0].invoiceNo,
          id: this.selected[0].id,
          status: this.selected[0].ifHandleFlag
        }
      })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable()
        }
      }
    }
  },
  watch: {
    pagination() {
      if (this.autoload) this.search()
    }
  },
  mounted() {
    this.$loadParams()
  }
}
</script>

